import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedNumber, FormattedMessage } from 'react-intl';
import { Label } from 'react-bootstrap';


import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import TableResponsive from 'components/layout/TableResponsive';
import CommissionServicePdfButton from 'components/layout/financial/CommissionServicePdfButton';


import CommissionServiceDetails from "components/modals/CommissionServiceDetails"; /* Todo */


import may from 'js/security';
import _ from "lodash";
import IntlDateTime from "../IntlDateTime";

class CommissionServiceInvoicesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCommissionService: null,
      showCommissionServiceDetails: false,
    };
  }

  showCommissionServiceDetails = (e,selectedCommissionService) => {
    e.stopPropagation();
    e.preventDefault();
    const { showDetailsAction } = this.props;
    if (showDetailsAction) {
      showDetailsAction(selectedCommissionService);
    } else {
      this.setState({ showCommissionServiceDetails: true, selectedCommissionService });
    }
  };

  closeCommissionServiceDetails = () => {
    this.setState({ showCommissionServiceDetails: false });
  };


  render() {
    const {
      intl: { messages },
      list,
      listName,
      inModal,
      user,
    } = this.props;
    const { showCommissionServiceDetails, selectedCommissionService } = this.state;

    /* Todo */
    const headers = {
      billNumber: messages.bill_number,
      status: messages.status,
      issued: messages.salesDoc.issued,
      salesManager: messages.salesDoc.target,
      /*dueTo: messages.salesDoc.due_date,*/
      totalDue: messages.salesDoc.total_due,
      /*payed: messages.salesDoc.payment,*/
      actions: messages.actions,
    };

    /* Todo */
    const rows = [];
    for (let i = 0; i < list.length; i++) {
      const invoice = list[i];
      const {
        number,
        number_prefix: numberPrefix,
        sum_gross: sumGross,
        is_auto_generated: isAutoGenerated,
        target,
        currency,
        cdate
      } = invoice;

      /* Todo */
      const actions = [<CommissionServicePdfButton invoice={invoice} key="pdf" />];

      const statuses = [];
      if (isAutoGenerated) {
        statuses.push(<span className="text-info">{messages.auto_generated}</span>);
      }

      // divide status Labels with whitespace
      const status = [...statuses];
      for (let i = status.length - 1; i > 0; i--) {
        status.splice(i, 0, <> </>);
      }

      const rowData = {
        billNumber: '#' + (numberPrefix || '') + (number || '?'),
        status: <>{status}</>,
        issued: <IntlDate date={cdate} />,
        salesManager: <>{target.username}</>,
        totalDue: <FormattedNumber value={sumGross} style="currency" currency={currency} />,
        actions,
        onClick: e => this.showCommissionServiceDetails(e, invoice),
      };

      rows.push(rowData);
    }

    return list.pending ? (
      <Loader />
    ) : (
      <>
        {!inModal || (inModal && !showCommissionServiceDetails) ? <TableResponsive headers={headers} rows={rows} hover /> : null}
        <CommissionServiceDetails /* Todo */
          alreadyInModal={inModal}
          show={showCommissionServiceDetails}
          close={this.closeCommissionServiceDetails}
          invoice={selectedCommissionService}
        />
      </>
    );
  }
}

CommissionServiceInvoicesList.defaultProps = {
  inModal: false,
  showDetailsAction: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

const mapDispatchToProps = dispatch => {
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CommissionServiceInvoicesList)
  )
);
